module.exports = __webpack_public_path__ + "img/water5-3.25437e74.jpg";